import { responseError } from '@/utils/errors';
import findResult, {
  assignIfExists, assignProps, findWithCode,
} from '@/utils/resultsHelper';
import withDraft from '@/utils/draftHelper';
import { states } from '@/constants/lifecycle';
import { findRole } from '../../state/state';
import { roleActionsDialogState } from './state';
import actions from '../constants';
import { roleCategories } from '../../constants';

const fetchRoleActions = withDraft((draft, action) => {
  const item = findRole(draft, action);
  assignProps(item.roleActions, {
    readStatus: states.PENDING,
    readErrors: [],
  });
  if (action.showDialog) {
    draft.activeRoleActions.readStatus = states.PENDING;
  }
});

const fetchRoleActionsSuccess = withDraft((draft, action) => {
  const item = findRole(draft, action);
  assignProps(item.roleActions, {
    readStatus: states.SUCCESS,
    readErrors: [],
  });
  item.roleActions.items = action.result.items;
});

const fetchRoleActionsError = withDraft((draft, action) => {
  const item = findRole(draft, action);
  assignProps(item.roleActions, {
    readStatus: states.ERROR,
    readErrors: [responseError(action)],
  });
});

const showRoleActions = withDraft((draft, action) => {
  draft.activeRoleActions.open = true;
  draft.activeRoleActions.code = action.code;
  draft.activeRoleActions.category = action.category;
  draft.activeRoleActions.roleActions = action.roleActions?.map(({ name }) => name) || [];
  draft.activeRoleActions.readStatus = action.readStatus;
});

const hideRoleActions = withDraft((draft) => {
  draft.activeRoleActions = roleActionsDialogState();
});

const editRoleActionsProperty = withDraft((draft, action) => {
  draft.activeRoleActions.roleActions = action.roleActions;
  draft.activeRoleActions.updateStatus = states.NONE;
  draft.activeRoleActions.updateErrors = [];
});

const updateRoleActions = withDraft((draft, action) => {
  const item = findRole(draft, action);
  draft.activeRoleActions.updateStatus = states.PENDING;
  draft.activeRoleActions.updateErrors = [];
  assignProps(item.roleActions, {
    updateStatus: states.PENDING,
    updateErrors: [],
  });
});

const updateRoleActionsSuccess = withDraft((draft, action) => {
  const item = findRole(draft, action);
  assignProps(item.roleActions, {
    updateStatus: states.NONE,
    updateErrors: [],
  });
  item.roleActions.items = action.result.items;

  draft.activeRoleActions = roleActionsDialogState();

  const categories = findWithCode(draft.roles, roleCategories, action.code);
  categories.forEach((category) => {
    const role = findResult(draft.roles, category, action.code);
    assignIfExists(role, {
      roleActions: {
        items: action.result.items,
        updateStatus: states.NONE,
        updateErrors: [],
      },
    });
  });
});

const updateRoleActionsError = withDraft((draft, action) => {
  const item = findRole(draft, action);
  assignProps(item.roleActions, {
    updateStatus: states.ERROR,
    updateErrors: [responseError(action)],
  });
  draft.activeRoleActions.updateStatus = states.ERROR;
  draft.activeRoleActions.updateErrors = [responseError(action)];
});

export default {
  [actions.EDIT_ROLE_ACTIONS_PROPERTY]: editRoleActionsProperty,
  [actions.FETCH_ROLE_ACTIONS]: fetchRoleActions,
  [actions.FETCH_ROLE_ACTIONS_ERROR]: fetchRoleActionsError,
  [actions.FETCH_ROLE_ACTIONS_SUCCESS]: fetchRoleActionsSuccess,
  [actions.HIDE_ROLE_ACTIONS]: hideRoleActions,
  [actions.SHOW_ROLE_ACTIONS]: showRoleActions,
  [actions.UPDATE_ROLE_ACTIONS]: updateRoleActions,
  [actions.UPDATE_ROLE_ACTIONS_ERROR]: updateRoleActionsError,
  [actions.UPDATE_ROLE_ACTIONS_SUCCESS]: updateRoleActionsSuccess,
};
